// extracted by mini-css-extract-plugin
module.exports = {"heading":"_02712f2b3b--heading--Ew1FR","content":"_02712f2b3b--content--vcX5s","advantage":"_02712f2b3b--advantage--UJbML","icon":"_02712f2b3b--icon--MBjVH"};